module.exports = __webpack_public_path__ + "static/media/cert_77.d27362c1.jpg";